import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response } from '@angular/http';

import  { Observable } from 'rxjs/Observable';

import { HttpClient } from './http-client.service';

import { RolledUpGoalsByOrgNode } from '../../entities';

import { Settings } from '../../settings';

import { DateConverter } from '../../utility/date-converter';

import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

import { CachedCallService } from './cached-call.service';

@Injectable()
export class RolledUpGoalsByOrgNodeService {

  private static readonly rolledUpGoalsByOrgNodeBaseUrl:string = `${Settings.apiUrl}/v1/RolledUpGoalsByOrgNodes`;

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getRolledUpGoalsByOrgNodes_ByOrgNodeId(fiscalYearId:number, orgNodeId:string, goalCategoryId:string):Promise<RolledUpGoalsByOrgNode[]>{

    let oDataBuilder:ODataBuilder = new ODataBuilder(RolledUpGoalsByOrgNodeService.rolledUpGoalsByOrgNodeBaseUrl);

    oDataBuilder
      .filter("FiscalYearId", ODataComparer.Equals, fiscalYearId)
      .filter("OrgNodeId", ODataComparer.Equals, orgNodeId)
      .filter("Goal/GoalCategoryId", ODataComparer.Equals, goalCategoryId)
      .expand("Goal")
      .orderBy("Goal/SortOrder");

    let rolledUpGoalsByOrgNodeUrl:string = oDataBuilder.toString();

    return this.http.get(rolledUpGoalsByOrgNodeUrl)
            .toPromise()
            .then(response => {
              //I'm using "any" and not RolledUpGoalsByOrgNode because RolledUpGoalsByOrgNode thinks that 
              //StartDate and EndDate are already dates, but they are not yet
              let formattedResponse:any[] = response.json().value;

              return formattedResponse;
            });
    
  }
  
  getRolledUpGoalsByOrgNodes_ByGoalId(fiscalYearId:number, goalId:string, parentOrgNodeId:string):Promise<RolledUpGoalsByOrgNode[]>{

    let oDataBuilder:ODataBuilder = new ODataBuilder(RolledUpGoalsByOrgNodeService.rolledUpGoalsByOrgNodeBaseUrl);

    oDataBuilder
      .filter("FiscalYearId", ODataComparer.Equals, fiscalYearId)
      .filter("OrgNode/ParentOrgNodeId", ODataComparer.Equals, parentOrgNodeId)
      .filter("GoalId", ODataComparer.Equals, goalId)
      .expand("OrgNode($expand=ParentOrgNode)")
      .orderBy("OrgNode/Name");

    let rolledUpGoalsByOrgNodeUrl:string = oDataBuilder.toString();

    return this.http.get(rolledUpGoalsByOrgNodeUrl)
            .toPromise()
            .then(response => {
              //I'm using "any" and not RolledUpGoalsByOrgNode because RolledUpGoalsByOrgNode thinks that 
              //StartDate and EndDate are already dates, but they are not yet
              let formattedResponse:any[] = response.json().value;

              return formattedResponse;
            });
    
  }
  
  getRolledUpGoalsByOrgNodes_ByGoalIdAndGrandparentOrgNodeId(fiscalYearId:number, goalId:string, grandparentOrgNodeId:string):Promise<RolledUpGoalsByOrgNode[]>{

    let oDataBuilder:ODataBuilder = new ODataBuilder(RolledUpGoalsByOrgNodeService.rolledUpGoalsByOrgNodeBaseUrl);

    oDataBuilder
      .filter("FiscalYearId", ODataComparer.Equals, fiscalYearId)
      .filter("OrgNode/ParentOrgNode/ParentOrgNodeId", ODataComparer.Equals, grandparentOrgNodeId)
      .filter("GoalId", ODataComparer.Equals, goalId)
      .expand("OrgNode($expand=ParentOrgNode)")
      .orderBy("OrgNode/ParentOrgNodeId")
      .orderBy("OrgNode/Name");

    let rolledUpGoalsByOrgNodeUrl:string = oDataBuilder.toString();

    return this.http.get(rolledUpGoalsByOrgNodeUrl)
            .toPromise()
            .then(response => {
              //I'm using "any" and not RolledUpGoalsByOrgNode because RolledUpGoalsByOrgNode thinks that 
              //StartDate and EndDate are already dates, but they are not yet
              let formattedResponse:any[] = response.json().value;

              return formattedResponse;
            });
    
  }
  
} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/rolled-up-goals-by-org-node.service.ts